/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 24/8/2022
 */

export const ReminderTriggerType = Object.freeze({
	REMINDER: -1,
	FOLLOWUP: 1,
	IMMEDIATE: 0,
})
